import React, { Component } from 'react'
import PropTypes from 'prop-types'

class LazyImage extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    image: null,
  }

  componentDidMount() {
    // Use class properties to avoid waiting for setState to execute
    this.mounted = true
    this.loadImage()
  }

  componentWillUnmount() {
    this.mounted = false
  }

  async loadImage() {
    const response = await this.props.loader()
    const loadedImage = response.default || response
    // Make sure to verify that the component is still valid,
    // otherwise an error will be thrown
    if (this.mounted) this.setState({ image: loadedImage })
  }

  render() {
    if (!this.state.image) return null

    return <img className={this.props.className} src={this.state.image} alt={this.props.alt} width={this.props.width} />
  }
}

LazyImage.propTypes = {
  loader: PropTypes.func.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  className: PropTypes.string,
}

LazyImage.defaultProps = {
  alt: '',
}

export default LazyImage
